const o = [500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30];
export {
  o as colorRange
};
